// REACT
import * as React from 'react';

// REDUX
import {connect} from 'react-redux';
import * as actions from 'actions';

// Chat Thread Class (Legacy from RN Codebase)
import MessageBackEnd from 'utils/ChatBackend';
const { setLogLikedStatus, setLogReviewedStatus, attachLogComment } = MessageBackEnd;

import { scrollToBottom } from 'utils/messagingUtils';

// VENDOR COMPONENTS
import VisibilitySensor from 'react-visibility-sensor';
import { MessageBox } from 'react-chat-elements';

// VENDOR UTILS
import anchorme from "anchorme";
import isEqual from 'lodash/isEqual';
import urlParser from 'js-video-url-parser/lib/base';
import 'js-video-url-parser/lib/provider/youtube';
import 'js-video-url-parser/lib/provider/vimeo';
import moment from 'moment-timezone';

// CUSTOM UTILS
import { constants } from 'constants/index';
import { toArray } from 'utils/lodashUtils';

// VENDOR COMPONENTS
import CircularProgress from 'material-ui/CircularProgress';
import ThumbUp from 'material-ui/svg-icons/action/thumb-up';
import CheckCircle from 'material-ui/svg-icons/action/check-circle';
import ChatBubbleEmpty from 'material-ui/svg-icons/communication/chat-bubble';
import ChatBubbleWithText from 'material-ui/svg-icons/communication/chat';
import Send from 'material-ui/svg-icons/content/send';
import Avatar from 'material-ui/Avatar';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Vimeo from '@u-wave/react-vimeo';
import YouTube from "react-yt";

// CUSTOM COMPONENTS
import VideoDocumentListItem from './VideoDocumentListItem';
import MessageBoxSC from '../Chat/MessageBoxSC';

class VideoDocumentList extends React.Component {
    props; // this is important only for typescript
    
    linkSharePanel = {};

    scrolled = false;

    chat = {
        clientHeight: 0,
        scrollHeight: 0,
        scrollTop: 0
    };
    reviewed = {};
    liked = {};
    comment = {
        parentId: null,
        text: null
    };
    
    messages = [];

    constructor(props) {
        super(props);
        this.state = {
            // offset: 0,
            // limit: 20,
            allowedToLoadPrevious: props.allowedToLoadPrevious,
            count: 0,
            firstScrollPosition: 0,
            keepToBottom: null,
            loadingPrevious: false,
            messages: [],
            messagesLoaded: props.messagesLoaded,
            scrolledToBottom: false,
            userScrolled: false,
        }
    }
    
    componentDidMount() {
        // Listen for user scroll, if they scroll stop scrolling to bottom
        this.linkSharePanel.addEventListener('wheel', this.handleWheelScroll, true);
        
        this.setState((prevState) => ({
            keepToBottom: setInterval(()=>{
                if (!prevState.userScrolled && !prevState.scrolledToBottom) {
                    // console.log('SCROLLING TO BOTTOM');
                    
                    if (!this.state.scrolledToBottom) this.scrollToBottom();
                    this.setState({
                        scrolledToBottom: true
                    });
                } else {
                    clearInterval(this.state.keepToBottom);
                    // console.log('YOU SCROLLED');
                    this.linkSharePanel.removeEventListener('wheel', this.handleWheelScroll, true);
                    // document.removeEventListener('wheel', this.handleWheelScroll, true);
                }
            }, 100) // Keeping this interval too short results in a backlog of scrolls to bottom leading to scrolling even after scrollevent or a delay in scroll event stopping the 
        }));
        
        // In case they don't scroll stop interval after 5 seconds
        setTimeout(()=>{
            clearInterval(this.state.keepToBottom);
            // console.log('CLEAR INTERVAL after 10 seconds');
            if (this.panel /* NEEDS TO BE CONDITIONAL IN CASE THE COMP IS NOT MOUNTED WITH CALLBACK FIRES */) { 
                this.linkSharePanel.removeEventListener('wheel', this.handleWheelScroll, true) 
            };
            // if (this.chat /* NEEDS TO BE CONDITIONAL IN CASE THE COMP IS NOT MOUNTED WITH CALLBACK FIRES */) this.chat.removeEventListener('wheel', this.handleWheelScroll, true);
        }, 10000)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newExpertContent !== nextProps.newExpertContent) {
            this.handleClearNotifications();
        }
    }

    componentDidUpdate(prevState, prevProps) {
        if ((this.props.messagesLoaded && prevProps.messagesLoaded === false && !this.state.scrolledToBottom) || ((this.props.messagesRedux && this.props.messagesRedux.length) !== (prevProps.messagesRedux && prevProps.messagesRedux.length) && !this.state.scrolledToBottom)) {
            // console.log('MESSAGES LOADED @ LIST', this.props.messagesLoaded, prevProps.messagesLoaded, prevProps);
            this.convertLinks();
        }
        if (prevProps.shouldScrollToBottom !== this.props.shouldScrollToBottom && this.props.shouldScrollToBottom) {
            // Scrolls to bottom that are triggered by parent VideoDocuments
            // this.scrollToBottom();
            this.props.resetShouldScrollToBottom();
            this.convertLinks();
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        if (this.props.messages && !isEqual(this.props.messages, nextProps.messages)) {
            // console.log('MESSAGE CHANGED, SHOULD UPDATE');
            return true; 
        }
        return true;
    }

    handleWheelScroll = (e) => {
        // console.log('YOU SCROLLED, stopping continuous scroll to bottom');
        
        this.props.resetShouldScrollToBottom();
        this.setState({
            scrolledToBottom: true
        });
        clearInterval(this.state.keepToBottom);
        this.linkSharePanel.removeEventListener('wheel', this.handleWheelScroll, true);

        this.setState({
            userScrolled: true
        }, ()=>{
            this.props.resetShouldScrollToBottom();
            this.setState({
                scrolledToBottom: true
            });
            clearInterval(this.state.keepToBottom);
            this.linkSharePanel.removeEventListener('wheel', this.handleWheelScroll, true);
            // console.log('SCROLL LISTENER DEACTIVATED', this.state.userScrolled);
        });
    }

    convertLinks = () => {
        // rce-mbox-text
        const messageNodesObject = document.querySelectorAll('.rce-mbox-text');
        // console.log('ARRAY OF MESSAGE NODES', messageNodesObject);
        
        messageNodesObject.forEach(messageNode => {
            // console.log('MESSAGE TEXT', messageNode, messageNode.innerText);
            if (anchorme.validate.email(messageNode.innerText) || anchorme.validate.url(messageNode.innerText) || anchorme.validate.ip(messageNode.innerText)) {
                messageNode.innerHTML = anchorme(messageNode.innerText, {
                    files: false,
                })
            } else {
                // IGNORE DUE TO SECURITY THREAT - WE NEED TO VALIDATE THE INPUT BEFORE ALLOWING IT TO BE ADDED TO THE HTML - ONLY URLs and EMAILs ALLOWED
            }
            
        })
    }
    
    scrollToBottom = () => {
        scrollToBottom(this.chat);
    }
    
    loadPreviousMessages = (isVisible) => {
        if (this.props.messages.length > 19 && this.props.allowedToLoadPrevious) {
            // console.log('IS VISIBLE?', isVisible, this.props.allowedToLoadPrevious, this.state.loadingPrevious);
            if (!isVisible || !this.props.allowedToLoadPrevious || this.state.loadingPrevious) { return };
            
            // console.log('COUNT CALC (count/count*19/length/nodeindex)', this.state.count, this.state.count * 19, this.props.messages.length - 1, this.props.messages.length - 1 - (this.state.count * 19));
            // const allmess = document.querySelectorAll(".messages .message");
            // console.log('MESSAGES', allmess );

            this.setState((prevState) => {
                return {
                    count: prevState.count + 1,
                    loadingPrevious: true,
                } 
            });

            return this.props.loadMoreMessages()
                .then((previousMessages) => {
                    // console.log('PREV MESS', previousMessages, previousMessages.length, document.querySelectorAll('.messages .message'));
                    
                    let lastLoadedMessage = document.querySelectorAll('.messages .message')[previousMessages.length];

                    process.nextTick(()=>{
                        lastLoadedMessage.parentNode.scrollTop = lastLoadedMessage.offsetTop - lastLoadedMessage.parentNode.offsetTop;
                        
                        this.convertLinks();
                        return this.setState({
                            loadingPrevious: false
                        });
                    });
                })
                .catch(console.log);
        }
    }

    getProviderProfile = (providerId) => {
        if (this.props.userData.provider) { // TODO: this goes over every provider which could be very inefficient at scale, not sure of a work around at the moment
            // console.log('USER DATA', this.props.userData);
            let providerData;
            this.props.providers.map(provider => {
                if (provider.uid === providerId) {
                    providerData = provider
                    providerData.firstName = provider.name && provider.name.first;
                    providerData.lastName = provider.name && provider.name.last;
                }
            })
            return providerData;
        } else {
            let profileData;
            
            this.props.providerProfiles.map(profile => {
                if (profile.uid === providerId) {
                    profileData = profile;
                }
            })
            
            return profileData;
        }
    }

    testDocURL = (url) => {
        // Allow only Google Drive, Box and DropBox
        if (/^(https?:\/\/)?drive\.google\.com\/[\w \.-]+?$/.test(url) || /^(https?:\/\/)?app\.box\.com\/s\/[\w \.-]+?$/ || /^(https?:\/\/)?www\.dropbox\.com\/s\/[\w \.-]+?$/) {
            return true;
        }
        return false;
    }

    renderVideo = (url) => {
        const video = urlParser.parse(url);

        if (video && video.mediaType === 'video' && video.provider === 'youtube') {
            return (<YouTube
                videoId={video.id}
                // showRelatedVideos={false}
                width={480}
                height={200}
                className="youtube"
                autoplay={false}
                // id="youtube"
            />)
        }
        if (video && video.mediaType === 'video' && video.provider === 'vimeo') {
            return (<Vimeo
                video={video.id}
                height={200}
                width={480}
                className="vimeo"
                autoplay={false}
            />)
        }
        
        return <p>Invalid video URL detected. Please supply a YouTube or Vimeo video URL or link. (e.g. https://www.youtube.com/embed/v/XXXXXXXX)</p>
    }

    handleClearNotifications = (isVisible) => {
        
        // console.log('CLEARING VIEWED NOTIFICATIONS');
        // console.log('REFRESHING NOTIFICATIONS @ VidDocLIST');
            
        // console.log('sender/service/user', this.props.userData && this.props.userData.uid, this.props.selectedService && this.props.selectedService.provider, this.props.selectedService && this.props.selectedService._id);

        this.setState({
            scrolledToBottom: isVisible
        })

        this.props.clearNotifications({type: 'newExpertContent', userId: this.props.userId, serviceId: this.props.selectedService._id})
        .then((res) => {
            this.props.refreshNotifications();
            this.props.getNotificationCounts({
                senderId: this.props.selectedService.provider,
                serviceId: this.props.selectedService._id,
                userId: this.props.userData.uid,
            });
        })
        .catch(console.log);
    }

    renderMessages = (messages) => {

        const messageNodes = this.props.messagesRedux.map((message, index) => {
            const { userData, channel } = this.props;
            // console.log('LOGS @ PHOTO LOG LIST', message);
            
            return (
                <div style={{ backgroundColor: 'white', margin: 10, boxShadow: (message.linkType === 'video') ? '1px 1px 12px 1px rgba(200,200,200,0.3)' : 'none', borderRadius: 5, marginBottom: 10, marginTop: (index === 0) ? 20 : 10 }} key={ index }>
                    <div ref={ (node) => {this.messages.push(node)}} className="message" style={{ maxWidth: '100%', cursor: (this.props.userData.provider) ? 'pointer' : 'default' }}>
                        
                        { message.linkType === 'video' &&
                            <div>
                                <span style={{padding: '10px 12px 15px 15px'}}>{message.videoTitle}</span>
                                {this.renderVideo(message.videoLink)}
                            </div>
                        }
                        {/* /^(https?:\/\/)?drive\.google\.com\/[\w \.-]+?$/ IS THIS A GOOGLE DRIVE DOC */}
                        {/* /^(https?:\/\/)?app\.box\.com\/s\/[\w \.-]+?$/ IS THIS A BOX DOC */}
                        {/* /^(https?:\/\/)?www\.dropbox\.com\/s\/[\w \.-]+?$/ IS THIS A DROPBOX DOC */}

                        {/* https://app.box.com/s/2if6xfmoqxokddtsw4gy9zmvv9qm8gxh
                        https://www.dropbox.com/s/b87f4d3vpjv9781/Cyno.rtf?dl=0 */}
                        {/* https://drive.google.com/open?id=15tX4PlVkEtrsuLCSE5O_jIekm98jn2jCaH3kLTEe17k */}
                        {/* ^(https?:\/\/)?www\.([\da-z\.-]+)\.([a-z\.]{2,6})\/[\w \.-]+?\.pdf$ */}

                        {/* /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/ */}
                        { message.linkType === 'document' && this.testDocURL(message.documentLink) &&
                            <div>
                                {/* {message.documentTitle} */}
                                <MessageBoxSC
                                    position={'left'}
                                    type={'file'}
                                    text={message.documentTitle}
                                    data={{
                                        status: {
                                            click: false,
                                            loading: 0,
                                        },
                                        uri: message.documentLink,
                                    }}
                                    onDownload={()=> {
                                        window.open(message.documentLink);
                                    }}
                                    css={`
                                        { 
                                            display: flex;
                                            flex-direction: column;  
                                            background-color: white;
                                            padding: 0 10px 0 10px;
                                        }
                                        .rce-mbox {
                                            box-shadow: 1px 1px 12px 1px rgba(200, 200, 200, 0.3);
                                        }
                                        .rce-mbox-left-notch {
                                            display: none;
                                        }
                                        .rce-mbox {
                                            border-top-left-radius: 30px;
                                        }
                                    `}
                                />
                            </div>
                        }
                        
                        {   message.linkType === 'document' && !this.testDocURL(message.documentLink) &&
                            <p>Invalid Link (Please use a shareable link from Dropbox, GoogleDrive, or Box)</p>
                        }

                        { userData && !userData.provider && // CLIENT ONLY VIEWS
                            <div> 
                               
                            </div>
                        }
                    </div>
                    
                    {   userData && userData.provider && // PROVIDER ONLY VIEWS
                        <div>
                            
                        </div>
                    }
                </div>
            );
        });

        return messageNodes;
    }

    render() {
        console.log('doc-props', this.props)
        
        const { maxHeight, messagesRedux, clearNotifications } = this.props;
        
        return (
            <div ref={ panel => this.linkSharePanel = panel } id="doc-panel" style={styles.chatPanel}>
                <div
                    ref={node => {
                        this.chat = node;
                    }}
                    className="messages"
                    style={{ ...styles.chatHistory, maxHeight }}
                >
                    { messagesRedux && messagesRedux.length > 19 && this.props.loadMoreMessages &&
                        <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'center' }}>
                            <VisibilitySensor
                                delay={ 0 } 
                                containment={ this.chat }
                                delayedCall={true}
                                partialVisibility={true}
                                active={!this.state.loadingPrevious}
                                // onChange={ this.loadPreviousMessages }
                            >
                                {({isVisible}) => {
                                    if (isVisible) {
                                        this.loadPreviousMessages(isVisible);
                                    }
                                    return <CircularProgress size={ 40 } thickness={ 5 } />
                                }}
                            </VisibilitySensor>
                        </div>
                    }
                    { messagesRedux.length > 0 &&
                        this.renderMessages(this.props.messagesRedux)
                    }
                    {
                        <VisibilitySensor
                            delay={ 0 } 
                            containment={ document.querySelector('.messages') }
                            // delayedCall={true}
                            partialVisibility={true}
                            // active={!this.state.loadingPrevious}
                            onChange={ this.handleClearNotifications }
                        />
                        // PUT SENSOR HERE AT THE BOTTOM SO THAT WHEN SCROLLED TO HERE IT WILL RESET THE NOTIFICATIIONS
                    }
                    { messagesRedux.length === 0  && // TODO: STYLE ME
                        <p style={ styles.noLinksNoticeStyles }>
                            There are no videos or documents here yet for this { this.props.userData.provider ? 'client' : 'service'  }.
                        </p>
                    }
                    {/* { messagesRedux.length === 0 && // TODO: STYLE ME
                        <div>
                        <CircularProgress size={ 40 } thickness={ 5 } />
                            <p>Loading</p>
                        </div>
                    } */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth, chat, provider, client, notification }) => {
    // console.log('MESSAGES FROM REDUX', chat.linkMessages, client.clientData.providerProfiles);
    // console.log('PROVIDERS @ loglist', client.clientData.providerProfiles); //get providers from clientDAta to show avatrars
    
    return {
        messagesRedux: chat.linkMessages,
        newExpertContent: notification.notifications.expertContent,
        providerProfiles: client.clientData.providerProfiles, // only accessible from client view of logs
        providers: provider.providers,
        userId: auth.authData.uid,
    };
};

export default connect(mapStateToProps, actions)(VideoDocumentList);

const styles = {
    chatHistory: { 
        overflow: 'auto' 
    },
    chatPanel: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        overflow: 'hidden',
    },
    commentInputStyles: {  
        border: 'none',
        // borderTop: '1px solid #ddd',
        fontSize: '16px',
        padding: '10px',
        paddingLeft: '30px',
        width: 'calc(100% - 50px)',
    },
    noLinksNoticeStyles: {
        paddingTop: '50%',
        fontSize: constants.text.baseFontStyles.fontSize,
        textAlign: 'center'
    }
};


// WEBPACK FOOTER //
// ./src/js/components/VideoDocumentSharing/VideoDocumentList.jsx